import tStatic from '../translations';
import { DICTIONARY } from '../translations/dictionary';

class PasswordServices {
  static hasValidationError = (password) => {
    let error = '';
    if (password?.length < 8) return tStatic(DICTIONARY.minimum8symbols);

    const hasUppercase = /[A-Z]/.test(password);
    const hasLowercase = /[a-z]/.test(password);
    const hasNumber = /[0-9]/.test(password);
    const hasSymbol = /[^A-Za-z0-9]/.test(password); // any non-alphanumeric character

    if (!hasUppercase) error = tStatic(DICTIONARY.noUpperCase);
    if (!hasLowercase) error = tStatic(DICTIONARY.noLowerCase);
    if (!hasNumber) error = tStatic(DICTIONARY.noNumber);
    else if (!hasSymbol) error = tStatic(DICTIONARY.noNonAlphanumeric);

    return error;
  };
}

export default PasswordServices;
